import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-de819b30")

_pushScopeId("data-v-de819b30")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_17 = { id: "xhook_report" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "spacName" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "banner",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_19 = { class: "spacName" }
const _hoisted_20 = { class: "gameTable" }
const _hoisted_21 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_22 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 基线版本: ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_27 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "客户端性能自动化")
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_29 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("总体风险，风险详情 ")
], -1)
const _hoisted_31 = { class: "corePerformance" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "spacName" }, "1. 核心场景内存趋势", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 版本间核心场景初始化时内存对象波动值风险级别定义规则:内存增幅波动 <5%，低风险；5%<=内存增幅波动<8%，中风险；内存增幅波动>=8%，高风险。 ", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 对比范围:DailyBuild性能版本对比上个月最终性能版本。 ", -1)
const _hoisted_35 = { class: "scene" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", null, "1、组件总内存（MB）", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", {
  id: "total_memory",
  style: {"width":"100%","height":"450px"}
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, "2、各组件内存（MB）", -1)
const _hoisted_39 = { class: "corePerformance performanceData" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能数据")
], -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, " 分支转测后，DailyBuild性能版本对比上个月度发布前稳定版各性能指标趋势。 ", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode(" Ps: "),
  /*#__PURE__*/_createVNode("span", { class: "gray" }, "灰色为上个版本数据"),
  /*#__PURE__*/_createTextVNode(" ，白色为当前内网最新版本数据 ")
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("内存数据")
], -1)
const _hoisted_44 = { class: "performanceTitle" }
const _hoisted_45 = {
  class: "performanceTable",
  style: {"font-size":"14px"}
}
const _hoisted_46 = {
  rowspan: 2,
  colspan: "2"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("td", { colspan: 3 }, "数据详情", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("td", { colspan: 2 }, "对比详情", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("td", null, "变化值(KB)", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("td", null, "变化趋势", -1)
const _hoisted_51 = {
  key: 1,
  style: {"background":"#5b9bd5","color":"#fff"}
}
const _hoisted_52 = { style: {"background":"#f2efef"} }
const _hoisted_53 = { style: {"background":"#f2efef"} }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm queryReport",
                    disabled: _ctx.loading
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "报告名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.change_report
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.xhook_reports, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: 
                      '【GR自动化】' +
                      _ctx.project_info.project_name +
                      '自动化xhook测试报告-' +
                      item.cur_version +
                      '-' +
                      item.test_time.replace('/', '').replace('/', '')
                    ,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_popconfirm, {
                            onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                            title: "确认删除该报告？",
                            placement: "top"
                          }, {
                            reference: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "info",
                                disabled: _ctx.get_is_super
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: "暂无管理员权限",
                                    placement: "top",
                                    disabled: !_ctx.get_is_super
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_4,
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    _ctx.test_info.cur_version +
                    " - " +
                    "时间: " +
                    _ctx.test_info.test_time), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, [
                      _withDirectives(_createVNode("table", _hoisted_20, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_21, [
                            _createVNode("img", {
                              src: _ctx.project_info.icon
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("td", _hoisted_22, _toDisplayString(_ctx.project_info.project_name), 1)
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_23,
                            _createVNode("span", null, _toDisplayString(_ctx.test_info.month), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_24,
                            _createVNode("span", null, _toDisplayString(_ctx.test_info.test_time), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_25,
                            _createVNode("span", null, _toDisplayString(_ctx.test_info.old_month.split(".")[0] +
                        "年" +
                        _ctx.test_info.old_month.split(".")[1] +
                        "月版本  " +
                        _ctx.test_info.old_version), 1)
                          ])
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_26,
                            _createVNode("span", {
                              style: _ctx.get_risk_color(_ctx.com_risk)
                            }, [
                              _createVNode("b", null, _toDisplayString(_ctx.com_risk), 1)
                            ], 4)
                          ]),
                          _hoisted_27,
                          _createVNode("td", null, [
                            _hoisted_28,
                            _createVNode("span", null, _toDisplayString(_ctx.test_info.month.split(".")[0] +
                        "年" +
                        _ctx.test_info.month.split(".")[1] +
                        "月版本  " +
                        _ctx.test_info.cur_version), 1)
                          ])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", null, [
                      _hoisted_29,
                      _hoisted_30,
                      _createVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _hoisted_33,
                        _hoisted_34,
                        _createVNode(_component_el_table, {
                          data: _ctx.core_data,
                          "header-cell-class-name": "TestConclusion",
                          "cell-class-name": "TestConclusionTable"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "scene",
                              label: "测试场景"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", _hoisted_35, _toDisplayString(scope.row.scene), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: 
                        '内存性能趋势' +
                        _ctx.test_info.cur_version +
                        '(对比' +
                        _ctx.test_info.old_version +
                        ')'
                      
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "trend",
                                  label: "组件总内存与趋势"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      class: 
                              scope.row.risk === '高风险' ? 'red' : 'green'
                            
                                    }, _toDisplayString("总内存:" +
                              scope.row.all_size +
                              "KB/趋势:" +
                              scope.row.all_trend), 3)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "trend2",
                                  label: "内存增量TOP的组件"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      class: 
                              scope.row.risk === '高风险' ? 'red' : 'green'
                            
                                    }, _toDisplayString(scope.row.top_obj +
                              "(增量:" +
                              scope.row.top_change +
                              "KB)"), 3)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "risk",
                              label: "趋势风险"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  class: scope.row.risk === '高风险' ? 'red' : 'green',
                                  style: {"font-weight":"bold"}
                                }, _toDisplayString(scope.row.risk), 3)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]),
                        _createVNode("div", null, [
                          _hoisted_36,
                          _withDirectives(_createVNode(_component_el_card, { class: "FPStrend" }, {
                            default: _withId(() => [
                              _hoisted_37
                            ]),
                            _: 1
                          }, 512), [
                            [_directive_loading, _ctx.loading]
                          ])
                        ]),
                        _createVNode("div", null, [
                          _hoisted_38,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memoryList, (item, index) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                              class: "FPStrend",
                              key: index
                            }, {
                              default: _withId(() => [
                                _createVNode("div", {
                                  id: 'each_memory' + item,
                                  style: {"width":"100%","height":"450px"}
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1536)), [
                              [_directive_loading, _ctx.loading]
                            ])
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memory_data, (value, key, index) => {
                        return (_openBlock(), _createBlock("div", { key: key }, [
                          _createVNode("p", _hoisted_44, _toDisplayString(index + 1) + "、" + _toDisplayString(key) + "_初始化组件内存 ", 1),
                          _createVNode("table", _hoisted_45, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("td", _hoisted_46, _toDisplayString(key) + "_初始化", 1),
                                _hoisted_47,
                                _hoisted_48
                              ]),
                              _createVNode("tr", null, [
                                _createVNode("td", null, _toDisplayString(_ctx.test_info.old_version + "(KB)"), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.previous_version), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.test_info.cur_version + "(KB)"), 1),
                                _hoisted_49,
                                _hoisted_50
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(value, (v, k) => {
                              return (_openBlock(), _createBlock("tbody", { key: k }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(v, (item, i) => {
                                  return (_openBlock(), _createBlock("tr", { key: i }, [
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 0,
                                          style: {"background":"#5b9bd5","color":"#fff"},
                                          colspan: k === 'all' ? 2 : 1,
                                          rowspan: v.length
                                        }, _toDisplayString(k), 9, ["colspan", "rowspan"]))
                                      : _createCommentVNode("", true),
                                    (k !== 'all')
                                      ? (_openBlock(), _createBlock("td", _hoisted_51, _toDisplayString(item.item), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", _hoisted_52, _toDisplayString(item.size), 1),
                                    _createVNode("td", _hoisted_53, _toDisplayString(item.previous), 1),
                                    _createVNode("td", null, _toDisplayString(item.baseline), 1),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend)
                                    }, _toDisplayString(item.change), 3),
                                    _createVNode("td", {
                                      class: _ctx.get_color(item.trend)
                                    }, _toDisplayString(item.trend), 3)
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _hoisted_54
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})